import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path d=\"M3 22L12 10L21 22H3Z\" stroke=\"currentColor\" stroke-linejoin=\"round\"></path><path d=\"M12 17L12 1\" stroke=\"currentColor\"></path><path d=\"M6 2L11 5L6 8V2Z\" stroke=\"currentColor\" stroke-linejoin=\"round\"></path><path d=\"M2 5L6 5\" stroke=\"currentColor\"></path><path d=\"M22 5L18 5\" stroke=\"currentColor\"></path><path d=\"M18 2L13 5L18 8V2Z\" stroke=\"currentColor\" stroke-linejoin=\"round\"></path>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_8))
}
export default { render: render }